import Vue from "vue";
import VueI18n from "vue-i18n";

import { Locale } from 'vant';

import { getLanguage, setLanguage } from "@/utils/cookies";
import enUS from 'vant/es/locale/lang/en-US';
import zhCN from 'vant/es/locale/lang/zh-CN';


import zh from "./zh";
import en from "./en";
import tr from "./tr";
import il from "./il";
import id from "./id";
import ae from "./ae";
import ph from "./ph";
import mm from "./mm";
import la from "./la";
import kh from "./kh";
import jp from "./jp";
import kr from "./kr";
import vn from "./vn";
import ru from "./ru";
import th from "./th";
import es from "./es";
import br from "./br";


Vue.use(VueI18n);

const messages = {
  'zh': {
    ...zh,
    ...zhCN
  },
  'en': {
    ...en,
    ...enUS
  },
  'tr': {
    ...tr
  },
  'il': {
    ...il
  },
  'id': {
    ...id
  },
  'ae': {
    ...ae
  },
  'ph': {
    ...ph
  },
  'mm': {
    ...mm
  },
  'la': {
    ...la
  },
  'kh': {
    ...kh
  },
  'jp': {
    ...jp
  },
  'kr': {
    ...kr
  },
  'ru': {
    ...ru
  },
  'th': {
    ...th
  },
  'vn': {
    ...vn
  }
  ,'es': {
    ...es
  }
  ,'br': {
    ...br
  }
};
export const getLocale = () => {
  const cookieLanguage = getLanguage();
  if (cookieLanguage) {
    document.documentElement.lang = cookieLanguage;
    return cookieLanguage;
  }

  const language = navigator.language.toLowerCase();
  const locales = Object.keys(messages);
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      document.documentElement.lang = locale;
      return locale;
    }
  }

  return "zh";
};

const CURRENT_LANG = getLocale();
console.log(CURRENT_LANG)
Locale.use(CURRENT_LANG, messages[CURRENT_LANG])

const i18n = new VueI18n({
  locale: CURRENT_LANG,
  messages
});


export const setI18nLanguage = lang => {
  i18n.locale = lang;
  document.documentElement.lang = lang;
  setLanguage(lang);
  Locale.use(lang, messages[lang]);
  return lang;
};

export default i18n;